<template>
  <div class="view">
    <div class="content">
      <div class="table_wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="date" label="任务"></el-table-column>
          <el-table-column prop="name" label="接收人"></el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <span @click="chooseadviser(scope.row)" class="action_btn">配置</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pag_wrap">
          <el-pagination background layout="prev, pager, next" :total="50"></el-pagination>
        </div>
      </div>
    </div>
    <chooseAdviserDialog :visible.sync="chooseadviserdialog" v-if="chooseadviserdialog"></chooseAdviserDialog>
  </div>
</template>
<script>
import chooseAdviserDialog from "@/components/dialog/chooseAdviserDialog.vue";

export default {
  name: "AnalyticsOpportunitySetting",
  components: {
    chooseAdviserDialog
  },
  data() {
    return {
      formdata: {
        user: ""
      },
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        }
      ],
      chooseadviserdialog: false
    };
  },
  methods: {
    // 顾问
    chooseadviser() {
      this.chooseadviserdialog = true;
    }
  }
};
</script>